import React from "react";
import Drawer from "@mui/material/Drawer";
import DrawerHeader from "../../requests/shared/helpers/DrawerHeader";
import DrawerFooterContainerLarge from "../../requests/shared/helpers/DrawerFooterContainerLarge";
import TextField from "@mui/material/TextField";
import { DrawerLabel, DrawerSaveFooter, INPUT_SX } from "./drawerInputs";

// A section header is just a label ("During shift", "End of day"); it groups
// blocks on the page and becomes a heading in the daily email.
function SectionBlockDrawer(props) {
  const [label, setLabel] = React.useState("");

  React.useEffect(() => {
    if (props.open) {
      setLabel(props.block?.config?.label || "");
    }
  }, [props.open, props.block]);

  return (
    <Drawer anchor="right" open={props.open} onClose={props.onClose}>
      <div className="w-[450px] h-full bg-slate-50 relative">
        <div className="max-h-screen overflow-auto">
          <DrawerHeader title="Section Header" onClose={props.onClose} />
          <div className="w-full px-6">
            <p className="text-slate-500 text-sm -mt-6">
              Groups the blocks below it, on the page and in the email
            </p>
            <div className="mt-7">
              <DrawerLabel>Label</DrawerLabel>
              <div className="mt-1">
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  placeholder="During shift"
                  value={label}
                  onChange={(e) => setLabel(e.target.value)}
                  InputProps={{ sx: INPUT_SX }}
                />
              </div>
            </div>
          </div>
          <DrawerFooterContainerLarge>
            <DrawerSaveFooter
              disabled={!label.trim()}
              onSave={() => {
                props.onSave({ label: label.trim() });
                props.onClose();
              }}
              onClose={props.onClose}
            />
          </DrawerFooterContainerLarge>
          <div className="h-[200px]"></div>
        </div>
      </div>
    </Drawer>
  );
}

export default SectionBlockDrawer;
